import React from "react";
import Sidebar from "../component/common/Sidebar";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { mainLayoutStyle } from "service/helpers/Constants";
import Header from "component/common/Header";
import { Sticky } from "semantic-ui-react";
// import "./style.scss"
// import Header from "../component/common/Header";
export function MainLayout(props) {
  const outerTheme = createMuiTheme({
    palette: {
      primary: {
        main: "#1A4BA1",
      },

      secondary: {
        main: "#00000",
      },
    },
  });
  const classes = mainLayoutStyle();
  return (
    <div className="mainLayout">
      {/* <Header /> */}
      <ThemeProvider theme={outerTheme}>
        <div className={classes.root + " pb-5"}>
          <Sidebar classes={classes} />
          <main className={classes.content + " w-100"} id="mg-main">
            <div>
              <Header />
            </div>
            {props.children}
          </main>
        </div>
      </ThemeProvider>
    </div>
  );
}
